//
//  SDKTokenThemeOverride.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { UnreachableCaseError } from "../../utils/UnreachableCaseError";
import { TokenType } from "../enums/SDKTokenType";
import { TokenOrigin } from "../support/SDKTokenOrigin";
import { BlurToken } from "../tokens/SDKBlurToken";
import { BorderToken } from "../tokens/SDKBorderToken";
import { ColorToken } from "../tokens/SDKColorToken";
import { BorderWidthToken, DimensionToken, DurationToken, FontSizeToken, LetterSpacingToken, LineHeightToken, OpacityToken, ParagraphSpacingToken, RadiusToken, SizeToken, SpaceToken, ZIndexToken, } from "../tokens/SDKDimensionToken";
import { GradientToken } from "../tokens/SDKGradientToken";
import { ShadowToken } from "../tokens/SDKShadowToken";
import { FontFamilyToken, FontWeightToken, ProductCopyToken, StringToken, } from "../tokens/SDKStringToken";
import { TextCaseToken } from "../tokens/SDKTextCaseToken";
import { TextDecorationToken } from "../tokens/SDKTextDecorationToken";
import { TypographyToken } from "../tokens/SDKTypographyToken";
import { VisibilityToken } from "../tokens/SDKVisibilityToken";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class TokenThemeOverride {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, value) {
        this.value = value;
        this.tokenId = model.tokenPersistentId;
        this.type = model.type;
        // @ts-expect-error TS(2345): Argument of type 'TokenOrigin' is not assignable t... Remove this comment to see the full error message
        this.origin = model.origin ? new TokenOrigin(model.origin) : null;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Manipulation
    toWriteObject() {
        var _a, _b, _c;
        return {
            data: this.valueToWriteObject(this.value, this.type),
            tokenPersistentId: this.tokenId,
            type: this.type,
            // @ts-expect-error TS(2322): Type '{ id: string | undefined; name: string | und... Remove this comment to see the full error message
            origin: this.origin
                ? {
                    id: (_a = this.origin.id) !== null && _a !== void 0 ? _a : undefined,
                    name: (_b = this.origin.name) !== null && _b !== void 0 ? _b : undefined,
                    sourceId: (_c = this.origin.sourceId) !== null && _c !== void 0 ? _c : undefined,
                }
                : undefined,
            createdAt: this.createdAt ? this.createdAt.toISOString() : undefined,
            updatedAt: this.updatedAt ? this.updatedAt.toISOString() : undefined,
        };
    }
    valueToWriteObject(value, type) {
        switch (type) {
            case TokenType.blur:
                return BlurToken.valueToWriteObject(value);
            case TokenType.border:
                return BorderToken.valueToWriteObject(value);
            case TokenType.color:
                return ColorToken.valueToWriteObject(value);
            case TokenType.gradient:
                return GradientToken.valueToWriteObject(value);
            case TokenType.dimension:
                return DimensionToken.valueToWriteObject(value);
            case TokenType.size:
                return SizeToken.valueToWriteObject(value);
            case TokenType.space:
                return SpaceToken.valueToWriteObject(value);
            case TokenType.opacity:
                return OpacityToken.valueToWriteObject(value);
            case TokenType.fontSize:
                return FontSizeToken.valueToWriteObject(value);
            case TokenType.lineHeight:
                return LineHeightToken.valueToWriteObject(value);
            case TokenType.letterSpacing:
                return LetterSpacingToken.valueToWriteObject(value);
            case TokenType.paragraphSpacing:
                return ParagraphSpacingToken.valueToWriteObject(value);
            case TokenType.borderWidth:
                return BorderWidthToken.valueToWriteObject(value);
            case TokenType.radius:
                return RadiusToken.valueToWriteObject(value);
            case TokenType.duration:
                return DurationToken.valueToWriteObject(value);
            case TokenType.zIndex:
                return ZIndexToken.valueToWriteObject(value);
            case TokenType.shadow:
                return ShadowToken.valueToWriteObject(value);
            case TokenType.string:
                return StringToken.valueToWriteObject(value);
            case TokenType.productCopy:
                return ProductCopyToken.valueToWriteObject(value);
            case TokenType.fontFamily:
                return FontFamilyToken.valueToWriteObject(value);
            case TokenType.fontWeight:
                return FontWeightToken.valueToWriteObject(value);
            case TokenType.typography:
                return TypographyToken.valueToWriteObject(value);
            case TokenType.textCase:
                return TextCaseToken.valueToWriteObject(value);
            case TokenType.textDecoration:
                return TextDecorationToken.valueToWriteObject(value);
            case TokenType.visibility:
                return VisibilityToken.valueToWriteObject(value);
            default:
                throw new UnreachableCaseError(type);
        }
    }
}
